// Ajusta el alto del iframe del widget Partsflow si el widget emite su alto
// por postMessage. Si nunca lo emite, el iframe se queda con la altura fija
// por breakpoint definida en CSS (ver snippets/widget-cotizacion.liquid).
// Pendiente confirmar con Partsflow el formato exacto del mensaje: se acepta
// {height: n}, {frameHeight: n} o {type: 'partsflow:height', height: n}.
class WidgetCotizacion extends HTMLElement {
  connectedCallback() {
    this.iframe = this.querySelector('iframe');
    if (!this.iframe) return;
    this.onMessage = this.onMessage.bind(this);
    window.addEventListener('message', this.onMessage);
  }

  disconnectedCallback() {
    window.removeEventListener('message', this.onMessage);
  }

  onMessage(event) {
    if (!this.iframe || event.source !== this.iframe.contentWindow) return;
    const data = event.data;
    if (!data || typeof data !== 'object') return;

    const height = data.height || data.frameHeight;
    if (typeof height === 'number' && height > 0) {
      this.iframe.style.height = `${height}px`;
    }
  }
}

customElements.define('widget-cotizacion', WidgetCotizacion);
